import { Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import { useEffect } from 'react';

import './App.css';

import Layout from './components/layout/Layout';

import Home from './pages/Home.jsx';
import Contact from './pages/Contact.jsx';
import About from './pages/About.jsx';

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search});
  }, [location]);

  return null;
}

function App() {

  return (
    <>
      <AnalyticsTracker />
      <Routes>

        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />




        </Route>
      </Routes>
    </>
  );
}

export default App;
